"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoilEnrichment = void 0;
const Tags_1 = require("./../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("./../CardType");
const SelectCard_1 = require("../../inputs/SelectCard");
const ResourceType_1 = require("../../ResourceType");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
class SoilEnrichment extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.SOIL_ENRICHMENT,
            tags: [Tags_1.Tags.MICROBE, Tags_1.Tags.PLANT],
            cost: 6,
            metadata: {
                cardNumber: 'X67',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.minus().microbes(1).plus().plants(5).digit.asterix();
                }),
                description: 'Spend 1 microbe from ANY of your cards to gain 5 plants.',
            },
        });
    }
    canPlay(player) {
        const microbeCardsWithResources = player.getResourceCards(ResourceType_1.ResourceType.MICROBE).filter((c) => c.resourceCount > 0);
        if (microbeCardsWithResources.length === 0)
            return false;
        if (microbeCardsWithResources.length === 1) {
            const microbeCard = microbeCardsWithResources[0];
            if (microbeCard.name === CardName_1.CardName.PSYCHROPHILES) {
                const cost = player.getCardCost(this) - (microbeCard.resourceCount - 1) * 2;
                return player.canAfford(cost, { microbes: false });
            }
        }
        return true;
    }
    play(player) {
        const microbeCardsWithResources = player.getResourceCards(ResourceType_1.ResourceType.MICROBE).filter((c) => c.resourceCount > 0);
        if (microbeCardsWithResources.length === 1) {
            player.removeResourceFrom(microbeCardsWithResources[0], 1, player.game, player, true);
            player.addResource(Resources_1.Resources.PLANTS, 5, { log: true });
            return undefined;
        }
        else if (microbeCardsWithResources.length > 1) {
            return new SelectCard_1.SelectCard('Select card to remove 1 microbe and gain 5 plants', 'Select', microbeCardsWithResources, (foundCards) => {
                player.removeResourceFrom(foundCards[0], 1, player.game, player, true);
                player.addResource(Resources_1.Resources.PLANTS, 5, { log: true });
                return undefined;
            });
        }
        return undefined;
    }
}
exports.SoilEnrichment = SoilEnrichment;
//# sourceMappingURL=SoilEnrichment.js.map